module.exports = __webpack_public_path__ + "static/media/ribbon2.95ec49b7.svg";